// Resolver metadata is read by canonical ID; legacy concentration is never
// promoted into resolver evidence. Product identity and RPC ordering stay intact.
export const CATALOG_RESOLVER_FIELDS = [
  'concentration_display', 'concentration_normalized',
  'concentration_resolution_status', 'concentration_resolver_confidence',
  'concentration_conflict', 'concentration_alternate_values',
  'concentration_evidence_sources', 'concentration_review_required',
]
export const CATALOG_RESOLVER_SELECT = ['id', ...CATALOG_RESOLVER_FIELDS].join(',')
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
export async function enrichCatalogVariantResolvers(rows, loadResolvers) {
  const unknown = rows.map(row => {
    const copy = { ...row }
    for (const field of CATALOG_RESOLVER_FIELDS) delete copy[field]
    return { ...copy, concentration_display: 'unknown', concentration_resolution_status: 'unknown' }
  })
  if (rows.length > 80) return unknown
  const ids = [...new Set(rows.map(row => row.id).filter(id => typeof id === 'string' && uuid.test(id)))]
  if (!ids.length) return unknown
  try {
    const { data, error } = await loadResolvers(ids)
    if (error || !Array.isArray(data)) return unknown
    const requested = new Set(ids)
    const byId = new Map()
    for (const row of data) {
      if (!requested.has(row?.id)) continue
      byId.set(row.id, byId.has(row.id) ? null : row)
    }
    return unknown.map(row => {
      const resolver = byId.get(row.id)
      if (!resolver) return row
      const metadata = Object.fromEntries(CATALOG_RESOLVER_FIELDS
        .filter(field => Object.hasOwn(resolver, field))
        .map(field => [field, resolver[field]]))
      return { ...row, ...metadata }
    })
  } catch {
    return unknown
  }
}
